import React, { type FC, type ReactNode, useMemo } from 'react';
import { ConfluenceExperimentsContext } from '@post-office/growth-common/confluence-experiments-context';

import EmojiResource from '@atlaskit/emoji/emoji-resource';

import { useSessionData } from '@confluence/session-data/entry-points/useSessionData.ts';
import { getEmojiProvider } from '@confluence/fabric-providers/entry-points/EmojiProvider.ts';
import { useCurrentFlagToShareActions } from '@confluence/flag-to-share-actions/entry-points/flag-to-share-actions.tsx';

import { getPageDataFromUrl } from './hooks/getPageDataFromUrl.ts';
import { usePageRecommendationData } from './hooks/usePageRecommendationData.tsx';
import { useInlineReactionsData } from './hooks/useInlineReactionsData.ts';

export const ConfluenceExperimentsProvider: FC<{ children: ReactNode }> = ({ children }) => {
	const { userId, cloudId } = useSessionData();
	const useShareActions = useCurrentFlagToShareActions();

	const experimentsContextValue = useMemo(() => {
		return {
			usePageRecommendationData,
			useInlineReactionsData,
			getPageDataFromUrl,
			emojiProvider: getEmojiProvider(EmojiResource, {
				userId,
				cloudId,
			}),
			useShareActions,
		};
	}, [userId, cloudId, useShareActions]);

	return (
		<ConfluenceExperimentsContext.Provider value={experimentsContextValue}>
			{children}
		</ConfluenceExperimentsContext.Provider>
	);
};
